import React, { useCallback, useState } from "react";
import { Button } from "components/bootstrap";
import CollectionModal from "collections/components/CollectionModal";
import useCollectionMutation from "collections/hooks/useCollectionMutation";
import CurrentUser from "logic/users/CurrentUser";
import { useTranslation } from "react-i18next";
const CreateCollectionButton = ({ bsSize = "md", bsStyle = "default", buttonText }) => {
  const { t } = useTranslation("enterprise_collections");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const toggleCreateModal = useCallback(() => setShowCreateModal((cur) => !cur), []);
  const { createCollection } = useCollectionMutation();
  const onCreate = (values) => createCollection({
    share_request: values.share_request,
    entities: [],
    title: values.title,
    description: values.description,
    id: values.id
  }).then((collection) => CurrentUser.reload().then(() => collection));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsSize, bsStyle, onClick: toggleCreateModal }, buttonText != null ? buttonText : t("shared.create_collection")), showCreateModal && /* @__PURE__ */ React.createElement(
    CollectionModal,
    {
      title: t("shared.create_collection"),
      submitButtonText: t("shared.create_collection"),
      submitLoadingText: t("create_collection_button.creating"),
      onSubmit: onCreate,
      onClose: toggleCreateModal,
      create: true
    }
  ));
};
export default CreateCollectionButton;
